var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "saas-page linear-workqueue-page" }, [
    _c("div", { staticClass: "saas-hero card-saas linear-page-hero" }, [
      _c("div", { staticClass: "saas-hero__main" }, [
        _c(
          "p",
          { staticClass: "saas-hero__crumb" },
          [
            _c("router-link", { attrs: { to: "/home" } }, [
              _vm._v(_vm._s(_vm.trans("general.home"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.trans("todo.todo")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c("span", { staticClass: "linear-eyebrow" }, [
          _vm._v(_vm._s(_vm.trans("todo.todo"))),
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "saas-hero__title" }, [
          _vm._v(_vm._s(_vm.trans("todo.todo"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "linear-command-actions" }, [
        _c(
          "button",
          {
            staticClass:
              "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.showFilterPanel = !_vm.showFilterPanel
              },
            },
          },
          [
            _c("admin-icon", { attrs: { name: "sliders" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.trans("general.filter")))]),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row linear-workqueue-grid" }, [
      _c("div", { staticClass: "col-12 col-lg-4" }, [
        _c(
          "div",
          {
            staticClass:
              "card-saas linear-admin-panel linear-admin-panel--sticky",
          },
          [
            _c("div", { staticClass: "linear-section-head" }, [
              _c("div", [
                _c("span", [_vm._v(_vm._s(_vm.trans("todo.todo")))]),
                _vm._v(" "),
                _c("h4", [_vm._v(_vm._s(_vm.trans("todo.add_new_todo")))]),
              ]),
            ]),
            _vm._v(" "),
            _c("todo-form", { on: { completed: _vm.getTodos } }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-lg-8" },
        [
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.showFilterPanel
              ? _c(
                  "div",
                  { staticClass: "card-saas linear-filter-card mb-3" },
                  [
                    _c("div", { staticClass: "linear-section-head" }, [
                      _c("div", [
                        _c("span", [_vm._v(_vm._s(_vm.trans("todo.todo")))]),
                        _vm._v(" "),
                        _c("h4", [_vm._v(_vm._s(_vm.trans("general.filter")))]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-md-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(_vm._s(_vm.trans("todo.keyword"))),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filterTodoForm.keyword,
                                expression: "filterTodoForm.keyword",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "keyword" },
                            domProps: { value: _vm.filterTodoForm.keyword },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.filterTodoForm,
                                  "keyword",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-md-6" }, [
                        _c(
                          "div",
                          { staticClass: "form-group linear-switch-row" },
                          [
                            _c("switches", {
                              attrs: { theme: "bootstrap", color: "success" },
                              model: {
                                value: _vm.filterTodoForm.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filterTodoForm, "status", $$v)
                                },
                                expression: "filterTodoForm.status",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.trans("todo.show_completed"))),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("date-range-picker", {
                              attrs: {
                                "start-date": _vm.filterTodoForm.start_date,
                                "end-date": _vm.filterTodoForm.end_date,
                                label: _vm.trans("general.date_between"),
                              },
                              on: {
                                "update:startDate": function ($event) {
                                  return _vm.$set(
                                    _vm.filterTodoForm,
                                    "start_date",
                                    $event
                                  )
                                },
                                "update:start-date": function ($event) {
                                  return _vm.$set(
                                    _vm.filterTodoForm,
                                    "start_date",
                                    $event
                                  )
                                },
                                "update:endDate": function ($event) {
                                  return _vm.$set(
                                    _vm.filterTodoForm,
                                    "end_date",
                                    $event
                                  )
                                },
                                "update:end-date": function ($event) {
                                  return _vm.$set(
                                    _vm.filterTodoForm,
                                    "end_date",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-md-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(_vm._s(_vm.trans("general.sort_by"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.filterTodoForm.sort_by,
                                  expression: "filterTodoForm.sort_by",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { name: "order" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.filterTodoForm,
                                    "sort_by",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c("option", { attrs: { value: "title" } }, [
                                _vm._v(_vm._s(_vm.trans("todo.title"))),
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "created_at" } }, [
                                _vm._v(_vm._s(_vm.trans("todo.date"))),
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "status" } }, [
                                _vm._v(_vm._s(_vm.trans("todo.status"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "option",
                                { attrs: { value: "description" } },
                                [_vm._v(_vm._s(_vm.trans("todo.description")))]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-md-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(_vm._s(_vm.trans("general.order"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.filterTodoForm.order,
                                  expression: "filterTodoForm.order",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { name: "order" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.filterTodoForm,
                                    "order",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c("option", { attrs: { value: "asc" } }, [
                                _vm._v(_vm._s(_vm.trans("general.ascending"))),
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "desc" } }, [
                                _vm._v(_vm._s(_vm.trans("general.descending"))),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.todos.total
            ? _c(
                "div",
                { staticClass: "admin-list-table-card linear-table-card" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "linear-section-head linear-section-head--table",
                    },
                    [
                      _c("div", [
                        _c("span", [_vm._v(_vm._s(_vm.trans("todo.todo")))]),
                        _vm._v(" "),
                        _c("h4", [_vm._v(_vm._s(_vm.trans("todo.todo")))]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-responsive" }, [
                    _c(
                      "table",
                      {
                        staticClass:
                          "table admin-data-table linear-dense-table mb-0",
                      },
                      [
                        _c("thead", [
                          _c(
                            "tr",
                            [
                              _c(
                                "sortable-th",
                                {
                                  attrs: {
                                    field: "title",
                                    "sort-by": _vm.filterTodoForm.sort_by,
                                    order: _vm.filterTodoForm.order,
                                  },
                                  on: { sort: _vm.sortList },
                                },
                                [_vm._v(_vm._s(_vm.trans("todo.title")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "sortable-th",
                                {
                                  attrs: {
                                    field: "created_at",
                                    "sort-by": _vm.filterTodoForm.sort_by,
                                    order: _vm.filterTodoForm.order,
                                  },
                                  on: { sort: _vm.sortList },
                                },
                                [_vm._v(_vm._s(_vm.trans("todo.date")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "sortable-th",
                                {
                                  attrs: {
                                    field: "status",
                                    "sort-by": _vm.filterTodoForm.sort_by,
                                    order: _vm.filterTodoForm.order,
                                  },
                                  on: { sort: _vm.sortList },
                                },
                                [_vm._v(_vm._s(_vm.trans("todo.status")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "sortable-th",
                                {
                                  attrs: {
                                    field: "description",
                                    "sort-by": _vm.filterTodoForm.sort_by,
                                    order: _vm.filterTodoForm.order,
                                  },
                                  on: { sort: _vm.sortList },
                                },
                                [_vm._v(_vm._s(_vm.trans("todo.description")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticClass: "admin-table-actions-cell" },
                                [_vm._v(_vm._s(_vm.trans("general.actions")))]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.todos.data, function (todo) {
                            return _c("tr", { key: todo.id }, [
                              _c("td", [
                                _c("span", {
                                  staticClass: "linear-table-primary",
                                  domProps: { textContent: _vm._s(todo.title) },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "span",
                                  { staticClass: "linear-table-muted" },
                                  [_vm._v(_vm._s(_vm._f("moment")(todo.date)))]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.getStatus(todo)),
                                },
                              }),
                              _vm._v(" "),
                              _c("td", [
                                _c("span", {
                                  staticClass:
                                    "linear-table-muted linear-table-description",
                                  domProps: {
                                    textContent: _vm._s(todo.description),
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "admin-table-actions-cell" },
                                [
                                  _c(
                                    "table-row-action-dropdown",
                                    [
                                      _c(
                                        "b-dropdown-item-button",
                                        {
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.toggleStatus(todo)
                                            },
                                          },
                                        },
                                        [
                                          _c("admin-icon", {
                                            attrs: {
                                              name: todo.status
                                                ? "x-circle"
                                                : "check-circle",
                                            },
                                          }),
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.trans(
                                                  "todo." +
                                                    (todo.status
                                                      ? "mark_as_incomplete"
                                                      : "mark_as_complete")
                                                )
                                              ) +
                                              "\n                                        "
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-dropdown-item-button",
                                        {
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.editTodo(todo)
                                            },
                                          },
                                        },
                                        [
                                          _c("admin-icon", {
                                            attrs: { name: "pencil" },
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.trans("todo.edit_todo")
                                              ) +
                                              "\n                                        "
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-dropdown-item-button",
                                        {
                                          directives: [
                                            {
                                              name: "confirm",
                                              rawName: "v-confirm",
                                              value: {
                                                ok: _vm.confirmDelete(todo),
                                              },
                                              expression:
                                                "{ok: confirmDelete(todo)}",
                                            },
                                          ],
                                          staticClass:
                                            "admin-row-actions__danger",
                                        },
                                        [
                                          _c("admin-icon", {
                                            attrs: { name: "trash" },
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.trans("todo.delete_todo")
                                              ) +
                                              "\n                                        "
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "admin-table-pagination-wrap" },
                    [
                      _c("pagination-record", {
                        attrs: {
                          "page-length": _vm.filterTodoForm.page_length,
                          records: _vm.todos,
                        },
                        on: {
                          "update:pageLength": function ($event) {
                            return _vm.$set(
                              _vm.filterTodoForm,
                              "page_length",
                              $event
                            )
                          },
                          "update:page-length": function ($event) {
                            return _vm.$set(
                              _vm.filterTodoForm,
                              "page_length",
                              $event
                            )
                          },
                          updateRecords: _vm.getTodos,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.todos.total
            ? _c(
                "div",
                {
                  staticClass:
                    "admin-list-table-card admin-empty-state linear-empty-state",
                  attrs: { role: "status" },
                },
                [
                  _c("div", { staticClass: "admin-empty-state__inner" }, [
                    _c(
                      "div",
                      {
                        staticClass: "admin-empty-state__icon-wrap",
                        attrs: { "aria-hidden": "true" },
                      },
                      [_c("admin-icon", { attrs: { name: "check-circle" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "admin-empty-state__title" }, [
                      _vm._v(_vm._s(_vm.trans("general.no_result_found"))),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "admin-empty-state__text" }, [
                      _vm._v(_vm._s(_vm.trans("todo.todo"))),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }